module.exports = __webpack_public_path__ + "LuirenCosplayCraft.webp?7cfb76f994b3869392c9ef99a71d4955";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/LuirenCosplayCraft.webp
// module id = 125
// module chunks = 0